import type {
  BuildCategoricalChartOptionsInput,
  CategoricalChartOptions,
} from './chartBuilder.types'
import { category, finiteNumber, uniqueCategories } from './chartData'
import { chartFieldLabel } from './chartPresentation'
import { firstField, type ResolvedChartFields } from './resolveChartFields'

export function buildHeatmapChartOptions(
  input: BuildCategoricalChartOptionsInput,
  fields: ResolvedChartFields,
): CategoricalChartOptions | null {
  const dimensionX = firstField(fields, ['dimension_x'])
  const dimensionY = firstField(fields, ['dimension_y'])
  const metric = firstField(fields, ['metric'])
  if (!dimensionX || !dimensionY || !metric) return null

  const xCategories = uniqueCategories(input.rows, dimensionX)
  const yCategories = uniqueCategories(input.rows, dimensionY)
  const xIndexes = new Map(xCategories.map((value, index) => [value, index]))
  const yIndexes = new Map(yCategories.map((value, index) => [value, index]))

  return {
    chart: { type: 'heatmap' },
    title: { text: '' },
    xAxis: { categories: xCategories },
    yAxis: { categories: yCategories, title: { text: '' } },
    colorAxis: { min: 0 },
    series: [
      {
        type: 'heatmap',
        name: chartFieldLabel(input, metric),
        dataLabels: { enabled: true, format: '{point.value}' },
        data: input.rows.map((row) => [
          xIndexes.get(category(row[dimensionX])) ?? 0,
          yIndexes.get(category(row[dimensionY])) ?? 0,
          finiteNumber(row[metric]),
        ]),
      },
    ],
    credits: { enabled: false },
  }
}
